"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useRouter } from "next/navigation";
import { Chip } from "../ui/Chip"; // your reusable chip

interface Tag {
  name: string;
  slug: string;
}
interface ChipsFormProps {
  chips: Tag[];
}
export default function ChipsForm(t0) {
  const $ = _c(9);
  const {
    chips
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== router) {
    t1 = tagSlug => {
      router.push(`/topic/${tagSlug}`);
    };
    $[0] = router;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleChipClick = t1;
  let t2;
  if ($[2] !== chips || $[3] !== handleChipClick) {
    let t3;
    if ($[5] !== handleChipClick) {
      t3 = tag => <Chip key={tag.slug} label={tag.name} onClick={() => handleChipClick(tag.slug)} />;
      $[5] = handleChipClick;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = chips.map(t3);
    $[2] = chips;
    $[3] = handleChipClick;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <div className="flex flex-wrap gap-3 p-4">{t2}</div>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}